var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 100,
    viewBox: "0 0 103 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2041_1321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4483 99.9999C55.0258 99.9999 70.8966 84.1192 70.8966 64.5293C70.8966 44.9394 55.0258 29.0586 35.4483 29.0586C15.8707 29.0586 0 44.9394 0 64.5293C0 84.1192 15.8707 99.9999 35.4483 99.9999Z",
    fill: "#DBC6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4641 27.1577H22.4506C22.1996 27.1577 21.9961 27.3613 21.9961 27.6125V85.3842C21.9961 85.6353 22.1996 85.8389 22.4506 85.8389H48.4641C48.7151 85.8389 48.9186 85.6353 48.9186 85.3842V27.6125C48.9186 27.3613 48.7151 27.1577 48.4641 27.1577Z",
    stroke: "#00008E",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.273 16.8623H49.3641C49.1131 16.8623 48.9097 17.0659 48.9097 17.3171V85.3844C48.9097 85.6355 49.1131 85.8391 49.3641 85.8391H100.273C100.524 85.8391 100.728 85.6355 100.728 85.3844V17.3171C100.728 17.0659 100.524 16.8623 100.273 16.8623Z",
    stroke: "#00008E",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.174 9.75879H53.9996C53.7486 9.75879 53.5452 9.96239 53.5452 10.2135V15.7251C53.5452 15.9763 53.7486 16.1799 53.9996 16.1799H96.174C96.425 16.1799 96.6285 15.9763 96.6285 15.7251V10.2135C96.6285 9.96239 96.425 9.75879 96.174 9.75879Z",
    stroke: "#00008E",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1562 38.3628H30.3219C30.0709 38.3628 29.8674 38.5664 29.8674 38.8175V45.6115C29.8674 45.8627 30.0709 46.0663 30.3219 46.0663H42.1562C42.4072 46.0663 42.6106 45.8627 42.6106 45.6115V38.8175C42.6106 38.5664 42.4072 38.3628 42.1562 38.3628Z",
    stroke: "#00008E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9019 24.2656H58.4896C58.2386 24.2656 58.0352 24.4692 58.0352 24.7204V34.6067C58.0352 34.8578 58.2386 35.0614 58.4896 35.0614H91.9019C92.1529 35.0614 92.3564 34.8578 92.3564 34.6067V24.7204C92.3564 24.4692 92.1529 24.2656 91.9019 24.2656Z",
    stroke: "#00008E",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7928 42.21H58.3805C58.1295 42.21 57.926 42.4136 57.926 42.6647V52.551C57.926 52.8022 58.1295 53.0058 58.3805 53.0058H91.7928C92.0438 53.0058 92.2472 52.8022 92.2472 52.551V42.6647C92.2472 42.4136 92.0438 42.21 91.7928 42.21Z",
    stroke: "#00008E",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8943 64.5293H66.152C65.901 64.5293 65.6975 64.7329 65.6975 64.984V84.7021C65.6975 84.9533 65.901 85.1569 66.152 85.1569H83.8943C84.1453 85.1569 84.3488 84.9533 84.3488 84.7021V64.984C84.3488 64.7329 84.1453 64.5293 83.8943 64.5293Z",
    stroke: "#00008E",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1958 2.27393V8.44036",
    stroke: "#00008E",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2041_1321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeIcon);
export default __webpack_public_path__ + "static/media/office-icon.a7eacc0bd85ed9eddd12359b75c78695.svg";
export { ForwardRef as ReactComponent };